import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";
import { TRANSACTION_CASH } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import useGenerateQueryParams from "./useGenerateQueryParams";

export const useCashManagement = () => {
  const navigate = useNavigate();

  const userInfo = useAppSelector((state) => state?.user?.userData);

  const [isPortfolioCash, setPortfolioCash] = useState<boolean>(false);

  const [selectedIds, setSelectedIds] = useState<any>([]);

  const [deleteConfirmation, setDeleteConfirmation] = useState<boolean>(false);

  const [openCashModal, setOpenCashModal] = useState<boolean>(false);

  const requestBody = useGenerateQueryParams("bankStatement");

  const { data: cashTransactions, isFetching: isCashTransactionLoading } =
    useFetchQuery({
      route: TRANSACTION_CASH,
      key: [QueryKeys.CASH_TRANSACTIONS_LIST, requestBody],
      requestBody,
    });

  const { mutate: handleMultiDelete, isLoading: deleteLoading } = useMutation({
    mutationFn: (ids: any) =>
      axiosInstance?.delete(`/transaction_cash/bulk_delete/`, {
        data: { ids: ids },
      }),
    onSuccess: () => {
      refetchQuery(QueryKeys.CASH_TRANSACTIONS_LIST);
      setDeleteConfirmation(false);
      setSelectedIds([]);
    },
  });

  return {
    isPortfolioCash,
    setPortfolioCash,
    cashTransactions: cashTransactions?.data,
    isCashTransactionLoading,
    setOpenCashModal,
    openCashModal,
    userInfo,
    navigate,
    deleteConfirmation,
    setDeleteConfirmation,
    handleMultiDelete,
    selectedIds,
    setSelectedIds,
    deleteLoading,
  };
};
